import { render, staticRenderFns } from "./linkGoodsSelect.vue?vue&type=template&id=f802d252&scoped=true"
import script from "./linkGoodsSelect.vue?vue&type=script&lang=js"
export * from "./linkGoodsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f802d252",
  null
  
)

export default component.exports